<template>
  <div class="m-15">
    <b-table
      striped
      bordered
      :select-mode="selectMode"
      selectable
      :busy="isBusy"
      hover
      :items="items"
      :fields="fields"
      @row-clicked="rowHandler"
    >
      <template v-slot:cell(isBound)="data">
        <b-badge v-if="data.item.isBound == false" variant="danger">
          {{ data.item.isBound == false ? "Não" : "Sim" }}
        </b-badge>
        <b-badge v-else variant="success">
          {{ data.item.isBound == false ? "Não" : "Sim" }}
        </b-badge>
      </template>
      <div slot="table-busy" class="text-center text-danger my-2">
        <strong>Carregando...</strong>
      </div>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import store from "../../../store";

export default {
  name: "vincularpromocao",
  components: {},
  data: () => {
    return {
      store,
      isBusy: false,
      isBound: false,
      items: [],
      fields: [
        { key: "codigo", label: "Código" },
        { key: "descricao", label: "Descrição" },
        { key: "data_inicial", label: "Data Inicial" },
        { key: "data_final", label: "Data Final" },
        { key: "isBound", label: "Vinculada" },
      ],
      selectMode: 'single',
    };
  },
  methods: {
    rowHandler(record) {
      localStorage.setItem("selecionado", record.codigo);
      localStorage.setItem("data_inicial", record.data_inicial);
      localStorage.setItem("data_final", record.data_final);

      this.$emit("can-continue", { value: true });

      // if (record.isBound) {
      //   this.$alert(
      //     "A promoção escolhida já está vinculada. Necessário desvincula-la para novo vínculo da promoção!",
      //     "Impossível Vincular",
      //     "error"
      //   );
      //   this.$emit("can-continue", { value: false });
      // } else {
      //   this.$emit("can-continue", { value: true });
      // }
    },

    async getPromocao() {
      const url = `${config.default.servidor}/gerencial/promocao/${localStorage
        .getItem("enterprise_id")
        .toString()}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: {
            authorization: `${config.default.authorizationBasic}`,
          },
        });

        if (response.data.data.length > 0) {
          this.items = response.data.data;
          this.isLoading = false;
          this.isBusy = false;
        } else {
          this.$alert(
            "Não encontramos promoções no seu ERP Accesys",
            "Erro ao buscar promoções",
            "error"
          );
          this.$router.go(-1);
        }
      } catch (error) {
        this.$alert(
          "Não encontramos promoções no seu ERP Accesys",
          "Erro ao buscar promoções",
          "error"
        );
        this.$router.go(-1);
      }
    },
  },

  async beforeMount() {
    this.isBusy = true;
    await this.getPromocao();
    this.store.limpaStore();
    localStorage.removeItem("image");
  },
  mounted() {
    this.$emit("update:title", "titulo");
  },
};
</script>
<style>
.m-15 {
  margin: 15px;
}
</style>